import React, { useState } from 'react';
import { getStoredMe } from './traccar';
import { requestShare } from './carCode';
import { shareIdentity } from './memberLink';

// "➕ Add a vehicle" — lets a logged-in owner/customer add another family member's
// car by entering the share code that person gave them. Sends an approval request
// to that car's owner; once approved the car appears in their own view.
// `compact` renders just a pill button that expands inline.
export default function AddSharedVehicle({ onAdded, style, buttonLabel = '➕ Add a vehicle' }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  const me = getStoredMe();
  const identity = shareIdentity(me);

  const submit = async () => {
    const c = code.trim();
    if (!c || busy) return;
    if (!identity) { setMsg('❌ Please sign in first.'); return; }
    setBusy(true); setMsg('');
    try {
      const r = await requestShare(c);
      if (r.status === 'approved') setMsg('✓ You already have access to that car.');
      else if (r.status === 'pending') setMsg('⏳ Already requested — waiting on the owner to approve.');
      else setMsg('✅ Request sent! Once the owner approves, the car shows up here.');
      setCode('');
      if (onAdded) onAdded();
    } catch (e) { setMsg(e && e.notFound ? '❌ No car found with that code. Double-check it with the owner.' : '❌ Couldn’t send the request. Try again.'); }
    setBusy(false);
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} style={{ background: 'linear-gradient(135deg,#16a34a,#15803d)', color: 'white', fontWeight: 700, fontSize: '13px', border: 'none', borderRadius: '9px', padding: '9px 15px', cursor: 'pointer', ...style }}>
        {buttonLabel}
      </button>
    );
  }
  return (
    <div style={{ border: '1px solid #bbf7d0', background: '#f0fdf4', borderRadius: '10px', padding: '12px', ...style }}>
      <div style={{ fontWeight: 800, fontSize: '13px', color: '#15803d', marginBottom: '2px' }}>➕ Add a family member’s car</div>
      <div style={{ fontSize: '11.5px', color: '#166534', marginBottom: '9px' }}>Enter the share code the car’s owner gave you. They’ll approve it, then the car appears here with full access.</div>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <input autoFocus style={{ flex: 1, minWidth: '160px', padding: '9px 12px', border: '1px solid #86efac', borderRadius: '8px', fontSize: '14px', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '1px', boxSizing: 'border-box' }}
          placeholder="TA-XXXXXXX" value={code} onChange={(e) => setCode(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') submit(); }} />
        <button onClick={submit} disabled={busy || !code.trim()} style={{ background: busy || !code.trim() ? '#94a3b8' : 'linear-gradient(135deg,#16a34a,#15803d)', color: 'white', fontWeight: 700, fontSize: '13px', border: 'none', borderRadius: '8px', padding: '9px 15px', cursor: busy || !code.trim() ? 'default' : 'pointer' }}>{busy ? 'Sending…' : 'Request'}</button>
        <button onClick={() => { setOpen(false); setMsg(''); setCode(''); }} style={{ background: 'transparent', border: 'none', color: '#64748b', fontWeight: 700, fontSize: '12px', cursor: 'pointer' }}>Cancel</button>
      </div>
      {msg && <div style={{ fontSize: '12px', fontWeight: 600, color: msg.startsWith('✅') || msg.startsWith('✓') ? '#15803d' : msg.startsWith('⏳') ? '#b45309' : '#b91c1c', marginTop: '9px' }}>{msg}</div>}
    </div>
  );
}
